import React from 'react';
import PropTypes from 'prop-types';
import { Space } from 'antd';
import { Currency, Text } from '@common/components';
import ExtensionDetailItemStateStyledValue from './extension-detail-item-state-styled-value';

export default function ExtensionDetailItemRate({
  value,
  state = '',
  overrided = false,
}) {
  const currencyValue = <Currency value={value} />;

  return (
    <Space>
      {overrided ? (
        <Text secondary bold deleted>
          {currencyValue}
        </Text>
      ) : (
        <ExtensionDetailItemStateStyledValue
          state={state}
          value={currencyValue}
        />
      )}
    </Space>
  );
}

ExtensionDetailItemRate.propTypes = {
  value: PropTypes.number.isRequired,
  state: PropTypes.string,
  overrided: PropTypes.bool,
};
